import { render, staticRenderFns } from "./training-category.vue?vue&type=template&id=794121ce&scoped=true"
import script from "./training-category.vue?vue&type=script&lang=js"
export * from "./training-category.vue?vue&type=script&lang=js"
import style0 from "./training-category.css?vue&type=style&index=0&id=794121ce&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "794121ce",
  null
  
)

export default component.exports